export const CREATE_GAME_COMPLETED =  "project/tictactoe/createGameCompleted";
export const GET_GAME_COMPLETED =  "project/tictactoe/getGameCompleted";
export const PLAY_MOVE_COMPLETED =  "project/tictactoe/playMoveCompleted";
export const GET_CRITERIA_COMPLETED =  "project/tictactoe/getCriteriaCompleted";
export const SET_PILOT_SUGGESTIONS_COMPLETED = "project/tictactoe/setPilotSuggestionsCompleted";
